import $ from 'jquery';
window.addEventListener("load", function(){
  var $window = $(window);

  let HeightAjuster = function(element){
    let _elm = $(element);
    let _m = 0;

    if($window.width() < 751){
      _elm.each(function(i) {
        let _$this = $(_elm[i]);
        _$this.find(".voice-content--txt").css({paddingBottom: ""});
      });
      return;
    }

    _elm.each(function(i){
      let _$this = $(_elm[i]);
      _$this.find(".voice-content--txt").css({paddingBottom: ""});
      if(_$this.height() > _m){
        _m = _$this.height();
      }
    });

    _elm.each(function(i){
      let _$this = $(_elm[i]);
      if(_$this.height() !== _m){
        let _diff = (_m - _$this.height());
        _$this.find(".voice-content--txt").css({paddingBottom : _diff});
      }
    });
  };

  let Resizer = function(){
    HeightAjuster(".voice-inner .voice-content");
  };

  $window.on("resize", Resizer);
  Resizer();
});